"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapStateToProps = exports["default"] = exports.Waypoints = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _nicbaseTranslation = require("nicbase-translation");

var _constants = require("../constants");

require("./waypoints-section.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var mapStateToProps = function mapStateToProps(state) {
  return {
    user: state.user,
    pois: state.informationLists.pois
  };
};

exports.mapStateToProps = mapStateToProps;

var Waypoints = function Waypoints(_ref) {
  var tour = _ref.tour,
      pois = _ref.pois,
      user = _ref.user;
  var startWaypoint = tour.wayPoints && tour.wayPoints.find(function (waypoint) {
    return waypoint.type === _constants.WAYPOINT_TYPES.START;
  });
  var endWaypoint = tour.wayPoints && tour.wayPoints.find(function (waypoint) {
    return waypoint.type === _constants.WAYPOINT_TYPES.END;
  });
  var intermediateWaypoints = tour.wayPoints && tour.wayPoints.filter(function (waypoint) {
    return waypoint.type === _constants.WAYPOINT_TYPES.INTERMEDIATE;
  });
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "details-waypoints-container"
  }, // start condition
  startWaypoint ? /*#__PURE__*/_react["default"].createElement("div", {
    className: "waypoint-container"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "waypoint-number-bubble"
  }, 1), /*#__PURE__*/_react["default"].createElement("div", {
    className: "bold"
  }, pois.find(function (poi) {
    return poi.id === startWaypoint.poiId;
  }) ? pois.find(function (poi) {
    return poi.id === startWaypoint.poiId;
  }).name : startWaypoint.poiName), startWaypoint.plannedStartTime && /*#__PURE__*/_react["default"].createElement("div", {
    className: "waypoint-planned-start-time"
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "widgets.tourBoard.plannedStart",
    tagName: "span"
  }), ":", ' ', /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedDate, {
    value: startWaypoint.plannedStartTime,
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "numeric",
    minute: "numeric",
    timeZone: user.timezone
  }))), startWaypoint.poiTriggerCondition && /*#__PURE__*/_react["default"].createElement("div", {
    className: "waypoint-start-condition"
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: _constants.TRIGGER_CONDITION_START_TRANSLATIONS[startWaypoint.poiTriggerCondition],
    tagName: "span"
  }))) : /*#__PURE__*/_react["default"].createElement("div", {
    className: "waypoint-container"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "waypoint-number-bubble"
  }, 1), /*#__PURE__*/_react["default"].createElement("div", {
    className: "start-time"
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "widgets.tourBoard.tourStart",
    tagName: "span"
  }), ":", ' ', /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedDate, {
    value: tour.scheduledStartTime,
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "numeric",
    minute: "numeric",
    timeZone: user.timezone
  })))), intermediateWaypoints.map(function (waypoint, index) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: waypoint.id,
      className: "waypoint-container"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "waypoint-number-bubble"
    }, index + 2), /*#__PURE__*/_react["default"].createElement("div", {
      className: "bold"
    }, pois.find(function (poi) {
      return poi.id === waypoint.poiId;
    }) ? pois.find(function (poi) {
      return poi.id === waypoint.poiId;
    }).name : waypoint.poiName), waypoint.plannedStopDuration && /*#__PURE__*/_react["default"].createElement("div", {
      className: "waypoint-planned-stop-duration"
    }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "widgets.tourBoard.plannedStopDuration",
      tagName: "span"
    }), ":", ' ', /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "widgets.tourBoard.hoursAndMinutes",
      values: {
        hours: (0, _constants.splitDuration)(Math.abs(waypoint.plannedStopDuration)).hours,
        minutes: (0, _constants.splitDuration)(Math.abs(waypoint.plannedStopDuration)).minutes
      }
    })), waypoint.scheduledTimeOfArrival && /*#__PURE__*/_react["default"].createElement("div", {
      className: "waypoint-planned-arrival-time"
    }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "widgets.tourBoard.scheduledTimeOfArrival",
      tagName: "span"
    }), ":", ' ', /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedDate, {
      value: waypoint.scheduledTimeOfArrival,
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "numeric",
      minute: "numeric",
      timeZone: user.timezone
    }))), waypoint.isAlternativeStart && /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "widgets.tourBoard.waypoint.isAlternativeStart",
      tagName: "span"
    }), waypoint.isAlternativeEnd && /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "widgets.tourBoard.waypoint.isAlternativeEnd",
      tagName: "span"
    }));
  }), // end condition
  endWaypoint ? /*#__PURE__*/_react["default"].createElement("div", {
    key: endWaypoint.id,
    className: "waypoint-container"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "waypoint-number-bubble"
  }, intermediateWaypoints.length + 2), /*#__PURE__*/_react["default"].createElement("div", {
    className: "bold"
  }, pois.find(function (poi) {
    return poi.id === endWaypoint.poiId;
  }) ? pois.find(function (poi) {
    return poi.id === endWaypoint.poiId;
  }).name : endWaypoint.poiName), endWaypoint.scheduledTimeOfArrival && /*#__PURE__*/_react["default"].createElement("div", {
    className: "waypoint-planned-arrival-time"
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "widgets.tourBoard.scheduledTimeOfArrival",
    tagName: "span"
  }), ":", ' ', /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedDate, {
    value: endWaypoint.scheduledTimeOfArrival,
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "numeric",
    minute: "numeric",
    timeZone: user.timezone
  }))), endWaypoint.poiTriggerCondition && /*#__PURE__*/_react["default"].createElement("div", {
    className: "waypoint-end-condition"
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: _constants.TRIGGER_CONDITION_END_TRANSLATIONS[endWaypoint.poiTriggerCondition],
    tagName: "span"
  }))) : /*#__PURE__*/_react["default"].createElement("div", {
    className: "waypoint-container"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "waypoint-number-bubble"
  }, intermediateWaypoints.length + 2), /*#__PURE__*/_react["default"].createElement("div", {
    className: "end-time"
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "widgets.tourBoard.tourEnd",
    tagName: "span"
  }), ":", ' ', /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedDate, {
    value: tour.scheduledEndTime,
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "numeric",
    minute: "numeric",
    timeZone: user.timezone
  })))));
};

exports.Waypoints = Waypoints;
Waypoints.propTypes = {
  tour: _propTypes["default"].shape({
    scheduledStartTime: _propTypes["default"].string,
    scheduledEndTime: _propTypes["default"].string,
    wayPoints: _propTypes["default"].arrayOf(_propTypes["default"].shape({}))
  }).isRequired,
  pois: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    id: _propTypes["default"].number.isRequired,
    name: _propTypes["default"].string.isRequired
  })).isRequired,
  user: _propTypes["default"].shape({
    timezone: _propTypes["default"].string
  }).isRequired
};
Waypoints.defaultProps = {};

var _default = (0, _reactRedux.connect)(mapStateToProps)(Waypoints);

exports["default"] = _default;